const TIMEZONE_CURRENCY_MAP = {
  'Asia/Kolkata': 'INR', 'Asia/Calcutta': 'INR', 'Asia/Colombo': 'INR',
  'America/New_York': 'USD', 'America/Chicago': 'USD', 'America/Denver': 'USD',
  'America/Los_Angeles': 'USD', 'America/Phoenix': 'USD', 'Pacific/Honolulu': 'USD',
  'America/Anchorage': 'USD', 'America/Boise': 'USD', 'America/Detroit': 'USD',
  'America/Indiana/Indianapolis': 'USD',
  'Europe/London': 'GBP', 'Europe/Belfast': 'GBP',
  'Europe/Berlin': 'EUR', 'Europe/Paris': 'EUR', 'Europe/Rome': 'EUR',
  'Europe/Madrid': 'EUR', 'Europe/Amsterdam': 'EUR', 'Europe/Brussels': 'EUR',
  'Europe/Vienna': 'EUR', 'Europe/Helsinki': 'EUR', 'Europe/Lisbon': 'EUR',
  'Europe/Dublin': 'EUR', 'Europe/Athens': 'EUR',
  'Australia/Sydney': 'AUD', 'Australia/Melbourne': 'AUD', 'Australia/Brisbane': 'AUD',
  'Australia/Perth': 'AUD', 'Australia/Adelaide': 'AUD', 'Australia/Hobart': 'AUD',
  'America/Toronto': 'CAD', 'America/Vancouver': 'CAD', 'America/Edmonton': 'CAD',
  'America/Winnipeg': 'CAD', 'America/Halifax': 'CAD', 'America/Montreal': 'CAD',
  'Asia/Singapore': 'SGD',
  'Asia/Dubai': 'AED', 'Asia/Muscat': 'AED',
};

/* Country → currency for every currency we hold exchange rates for.
   Eurozone members all map to EUR. */
const COUNTRY_CURRENCY_MAP = {
  IN: 'INR', US: 'USD', GB: 'GBP', AU: 'AUD', CA: 'CAD', SG: 'SGD', AE: 'AED',
  DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR', AT: 'EUR',
  PT: 'EUR', IE: 'EUR', FI: 'EUR', GR: 'EUR', SK: 'EUR', SI: 'EUR', LV: 'EUR',
  LT: 'EUR', EE: 'EUR', LU: 'EUR', CY: 'EUR', MT: 'EUR', HR: 'EUR',
};

/* Region subtag from the browser's language tags, e.g. "en-GB" → "GB". */
function detectRegion() {
  const langs = [...(navigator.languages || []), navigator.language].filter(Boolean);
  for (const lang of langs) {
    const m = /[-_]([A-Za-z]{2})(?:$|[-_])/.exec(lang);
    if (m) return m[1].toUpperCase();
  }
  return null;
}

/* Best-effort local currency, no dropdown needed: a saved choice wins, then
   the timezone, then the browser language's region, then INR. */
export function detectCurrency() {
  const saved = localStorage.getItem("photentra_currency");
  if (saved) return saved;
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (TIMEZONE_CURRENCY_MAP[tz]) return TIMEZONE_CURRENCY_MAP[tz];
    const region = detectRegion();
    if (region && COUNTRY_CURRENCY_MAP[region]) return COUNTRY_CURRENCY_MAP[region];
    return 'INR';
  } catch {
    return 'INR';
  }
}

const CURRENCY_LOCALES = {
  INR: 'en-IN',
  USD: 'en-US',
  EUR: 'de-DE',
  GBP: 'en-GB',
  AUD: 'en-AU',
  CAD: 'en-CA',
  SGD: 'en-SG',
  AED: 'ar-AE',
};

export function formatPrice(amountINR, currency, rates) {
  if (!rates || !currency || currency === 'INR') {
    return `₹${Math.round(parseFloat(amountINR)).toLocaleString("en-IN")}`;
  }
  const rateObj = rates.find((r) => r.currency === currency);
  if (!rateObj) return `₹${Math.round(parseFloat(amountINR)).toLocaleString("en-IN")}`;

  const converted = parseFloat(amountINR) * parseFloat(rateObj.rate);
  const rounded = Math.round(converted * 100) / 100;
  const locale = CURRENCY_LOCALES[currency] || 'en-US';

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: rounded % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(rounded);
  } catch {
    return `${rateObj.symbol || currency}${rounded.toLocaleString(locale)}`;
  }
}

export function getConvertedAmount(amountINR, currency, rates) {
  if (!rates || !currency || currency === 'INR') return parseFloat(amountINR);
  const rateObj = rates.find((r) => r.currency === currency);
  if (!rateObj) return parseFloat(amountINR);
  return Math.round(parseFloat(amountINR) * parseFloat(rateObj.rate) * 100) / 100;
}
